module.exports = __webpack_public_path__ + "6d2d17f7c49a5af28151454b6a32aecb.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/vestigium.png
// module id = 632
// module chunks = 0